export default __webpack_public_path__ + "40724dbed863164efac6d799af6c7130.png";